import React from "react";

const RulesReferral = () => {
  return <div>RulesReferral</div>;
};

export default RulesReferral;